// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"XD-z","smallCardRow":"YD-z","largeCardRow":"ZD-z","productSearchRow":"_D-z","curatedRow":"aE-z"};